import closeWhiteIcon from '../../../assets/images/shared/icons/close-white.svg';

/**
 * Renders a <ApprovalCreditLimitTooltip/> component
 * @param props
 * @param props.text - Text to display
 * @param props.dismiss - To dismiss the tooltip
 */
const ApprovalCreditLimitTooltip = ({ text, dismiss }) => (
  <span
    data-testid="oa-credit-limit__tooltip"
    className={`oa-credit-limit__tooltip ${
      dismiss ? 'oa-credit-limit__tooltip--dismiss' : ''
    }`}>
    <span className="oa-credit-limit__tooltip-text">{text}</span>
    <span tabIndex="0" role="button" className="oa-credit-limit__tooltip-close">
      <img src={closeWhiteIcon} alt="close tooltip" width="14" height="14" />
    </span>
  </span>
);

export default ApprovalCreditLimitTooltip;
